'use client';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '~/GlobalRedux/store';

export type Languages = 'pt' | 'en' | 'es';

export interface LanguageSlice {
  language: Languages;
}

const initialState: LanguageSlice = {
  language: 'pt',
};

export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<Languages>) => {
      state.language = action.payload;
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export const languageSelector = (state: RootState) => state.language.language;
export default languageSlice.reducer;
